module.exports = __webpack_public_path__ + "img/banner_cpjs.8aae9c68.png";